import { Employee, GetDocumentsQuery } from "@skbkontur/staff-common";
import { AdditionalColumn, ListType } from "@skbkontur/staff-selector-widget";
import { ObjectDocument } from "@skbkontur/staff-common/lib/client/clientTypes";

export interface ImportFromEmployeeServiceOptions {
    single: true;
    additionalColumn?: AdditionalColumn;
    listType?: ListType;
    selected?: (e: Employee) => boolean;
}

export type EmployerDocumentTag = string;

export interface ImportEmployerDocumentsColumn {
    title: string;
    tagFieldName: string;
    renderValue?: (value: string | string[]) => string;
}

export enum ImportEmployerDocumentsFilterType {
    Month = "targetMonth",
    Quarter = "targetQuarter",
}

export type RequestsTags = string[][];

export interface DocumentsFilterSelectValue {
    label: string;
    value: string | number;
    requestsTags: RequestsTags;
}

export interface ImportEmployerDocumentsFilter {
    filterTypes: ImportEmployerDocumentsFilterType[];
    selectValues: Record<ImportEmployerDocumentsFilterType, DocumentsFilterSelectValue[]>;
    hideFilterSelectFor?: ImportEmployerDocumentsFilterType[];
    defaultValue?: {
        filterType?: ImportEmployerDocumentsFilterType;
        selectValue?: DocumentsFilterSelectValue["value"];
    };
}

export interface ImportEmployerDocumentsOptions {
    gfv: string;
    requestsTags?: RequestsTags;
    tagsForView?: string[];
    filterTagsCallback?: (tag: EmployerNormalizedTag) => boolean;
    title: string;
    description?: string;
    importResultDocumentNameGenitive?: string;
    instanceNumber?: number | string; // deprecated
    snils?: string; // deprecated
    importArguments?: string[];
    employeeIds?: string[];
    warning?: string;
    hint?: string;
    columns: ImportEmployerDocumentsColumn[];
    filter?: ImportEmployerDocumentsFilter;
    getDocumentsQuery?: Partial<GetDocumentsQuery>;
    filterByEmployeeRelations?: boolean;
}

export type EmployerDocument = ObjectDocument;

export interface EmployerNormalizedTag {
    sourceTag: EmployerDocumentTag;
    normalizedTag: {
        [key: string]: string;
    };
    documentId: string;
    date: string;
    dateIso: string;
    content?: {
        report: {
            link?: string;
            gfv?: number;
        };
    };
}
